import React, { lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';

const ManualBuildRedirect = lazy(() => import('../components/shared/section-shells/ManualBuildRedirect'));
const ProcurementRouter = lazy(() => import('../components/ordering/order-management/ProcurementRouter'));
const HistoricalPurchases = lazy(() => import('../components/ordering/historical-purchases/HistoricalPurchases'));

export const orderingRoutes = (
  <>
    <Route path="/manual-build" element={<ManualBuildRedirect />} />
    <Route path="/auto-build" element={<Navigate to="/order-management/orders" replace />} />
    <Route path="/order-management/*" element={<ProcurementRouter />} />
    <Route path="/historical-purchases" element={<HistoricalPurchases />} />
    <Route path="/procurement" element={<ManualBuildRedirect />} />
  </>
);
